'use strict';

module.exports = /*@ngInject*/ ["$rootScope", "$scope", "DetailWindowFactory", "InvestigateStateChangeFactory", "MonitoringStoreService","ProjectService", function TilesMonitoringViewController(
    $rootScope,
    $scope,
    DetailWindowFactory, 
    InvestigateStateChangeFactory, 
    MonitoringStoreService,
    ProjectService) {

    var vm = this;

    vm.viewMode = $rootScope.monitoringViewMode && $rootScope.monitoringViewMode.name;
    getTrainsData();

    var deRegisterTrainsUpdatedListener = $rootScope.$on('trains-updated', function(){
        getTrainsData();
    });

    $rootScope.$on('view-mode-updated', function(event, mode){
        vm.viewMode = mode && mode.name; 
    });

    function getTrainsData() {
        vm.currentProjectId = ProjectService.getSelectedProjectId();
        vm.trains = MonitoringStoreService.getTrains(vm.currentProjectId);
        var projectNameEntities = vm.trains.reduce((acc, train) => {
            if (!acc[train.projectName]) {
                acc[train.projectName] = true;
            }
            return acc;
        }, {});
        vm.projects = vm.currentProjectId === 0 ?  Object.keys(projectNameEntities).map(name => {
            return {
                name: name,
                isOpen: true
            }
        }): null;
    }

    vm.openDetailWindow = function (selectedTrain) {
        DetailWindowFactory.openModal(selectedTrain, function (train) {
            vm.investigateTrain(train);
        }, function () {
        });
    };

    vm.investigateTrain = function (train) {
        InvestigateStateChangeFactory.investigateInDetail(train);
    };

    vm.sorterFunc = function(train){
        return parseInt(train.officialId);
    };

    vm.showInformation = function () {
        // TODO should show tooltip information of hovered train tile. Which info??
    };

    $scope.$on('$destroy', function () {
        console.log("destrying tiles")
        deRegisterTrainsUpdatedListener();
    });
}];